import React from 'react'
import Logo from "../img/logo2.png"
export function Footer(){
    return (
      <footer >
        <img src={Logo} alt='' />
        <span>Made with ❤️ <b>React.Js</b></span>
      </footer>
    )
  }
  
  

